// import React from "react";
// import { Link } from "react-router-dom";
// import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
// import "./footer.css";
// import img from './rootservicesQR.jpg'
// const Footer = () => {
//   return React.createElement(
//     "footer",
//     { className: "rs-footer" },

//     // Top Section
//     React.createElement(
//       "div",
//       { className: "rs-footer-top" },

//       // Quick Links
//       React.createElement(
//         "div",
//         { className: "rs-footer-col" },
//         React.createElement("h4", null, "Quick Links"),
//         React.createElement(
//           "ul",
//           null,
//           React.createElement("li", null, React.createElement(Link, { to: "/" }, "Home")),
//           React.createElement("li", null, React.createElement(Link, { to: "/servicehome" }, "Services")),
//           React.createElement("li", null, React.createElement(Link, { to: "/like" }, "Liked")),
//           React.createElement("li", null, React.createElement(Link, { to: "/profile" }, "Profile"))
//         )
//       ),

//       // Services
//       React.createElement(
//         "div",
//         { className: "rs-footer-col" },
//         React.createElement("h4", null, "Services"),
//         React.createElement(
//           "ul",
//           null,
//           React.createElement("li", null, React.createElement(Link, { to: "/specialoffer" }, "Special Offers"))
//         )
//       ),

//       // Play Store QR
//       React.createElement(
//         "div",
//         { className: "rs-footer-col" },
//         React.createElement("h4", null, "Download App"),
//         React.createElement(
//           "div",
//           { className: "playstore-qr" },
//           React.createElement("img", {
//             src: img,
//             alt: "Play Store QR",
//           })
//         )
//       ),

//       // Location
//       React.createElement(
//         "div",
//         { className: "rs-footer-col rs-footer-location" },
//         React.createElement("h4", null, "Our Location"),
//         React.createElement("p", null, "ROOT SERVICE"),
//         React.createElement("p", null, "SHOP.NO3, HK.HEIGHTS"),
//         React.createElement("p", null, "KALYANDURG, BYPASS, TOWARDS DMART, SERVICE RD"),
//         React.createElement("p", null, "RUDRAMPETA, ANANTAPUR, ANDHRAPRADESH"),
//         React.createElement("p", null, "PinCode: 515004, INDIA"),
//         React.createElement(
//           "div",
//           { className: "rs-footer-map" },
//           React.createElement("iframe", {
//             title: "Our Location Map",
//             src: "https://www.google.com/maps/embed?pb=!1m18...",
//             allowFullScreen: true,
//             loading: "lazy",
//             referrerPolicy: "no-referrer-when-downgrade",
//           })
//         )
//       )
//     ),

//     // Bottom Section
//     React.createElement(
//       "div",
//       { className: "rs-footer-bottom" },
//       React.createElement(
//         "div",
//         { className: "rs-footer-rights" },
//         React.createElement("p", null, `© ${new Date().getFullYear()} Root Service. All rights reserved.`),
//         React.createElement(
//           "p",
//           null,
//           "Designed & Developed by ",
//           React.createElement("strong", null, "Actrofite Infotech Pvt Ltd")
//         )
//       ),
//       React.createElement(
//         "div",
//         { className: "rs-footer-social" },
//         React.createElement(
//           "a",
//           { href: "https://facebook.com", target: "_blank", rel: "noopener noreferrer", className: "facebook" },
//           React.createElement(FaFacebookF)
//         ),
//         React.createElement(
//           "a",
//           { href: "https://twitter.com", target: "_blank", rel: "noopener noreferrer", className: "twitter" },
//           React.createElement(FaTwitter)
//         ),
//         React.createElement(
//           "a",
//           { href: "https://instagram.com", target: "_blank", rel: "noopener noreferrer", className: "instagram" },
//           React.createElement(FaInstagram)
//         ),
//         React.createElement(
//           "a",
//           { href: "https://linkedin.com", target: "_blank", rel: "noopener noreferrer", className: "linkedin" },
//           React.createElement(FaLinkedin)
//         )
//       )
//     )
//   );
// };

// export default Footer;


// import React from "react";
// import { Link } from "react-router-dom";
// import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
// import "./footer.css";
// import img from './rootservicesQR.jpg';

// const Footer = () => {
//   const playStoreLink = "https://play.google.com/store/apps/details?id=com.rootservices.rootservices";

//   return (
//     <footer className="rs-footer">

//       {/* Top Section */}
//       <div className="rs-footer-top">

//         {/* Quick Links */}
//         <div className="rs-footer-col">
//           <h4>Quick Links</h4>
//           <ul>
//             <li><Link to="/">Home</Link></li>
//             <li><Link to="/servicehome">Services</Link></li>
//             <li><Link to="/like">Liked</Link></li>
//             <li><Link to="/profile">Profile</Link></li>
//           </ul>
//         </div>

//         {/* Services */}
//         <div className="rs-footer-col">
//           <h4>Services</h4>
//           <ul>
//             <li><Link to="/specialoffer">Special Offers</Link></li>
//           </ul>
//         </div>

//         {/* Play Store QR */}
//         <div className="rs-footer-col">
//           <h4>Download App</h4>
//           <div className="playstore-qr">
//             {/* QR Image as clickable link */}
//             <a href={playStoreLink} target="_blank" rel="noopener noreferrer">
//               <img src={img} alt="Play Store QR" />
//             </a>
//             <br/>
//             {/* Additional download button */}
//             <a
//               href={playStoreLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="download-btn"
//             >
//               Click here to download
//             </a>
//           </div>
//         </div>

//         {/* Location */}
//         <div className="rs-footer-col rs-footer-location">
//           <h4>Our Location</h4>
//           <p>ROOT SERVICE</p>
//           <p>SHOP.NO3, HK.HEIGHTS</p>
//           <p>KALYANDURG, BYPASS, TOWARDS DMART, SERVICE RD</p>
//           <p>RUDRAMPETA, ANANTAPUR, ANDHRAPRADESH</p>
//           <p>PinCode: 515004, INDIA</p>
//           <div className="rs-footer-map">
//             <iframe
//               title="Our Location Map"
//               src="https://www.google.com/maps/embed?pb=!1m18..."
//               allowFullScreen
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//             />
//           </div>
//         </div>

//       </div>

//       {/* Bottom Section */}
//       <div className="rs-footer-bottom">
//         <div className="rs-footer-rights">
//           <p>© {new Date().getFullYear()} Root Service. All rights reserved.</p>
//           <p>
//             Designed & Developed by <strong>Actrofite Infotech Pvt Ltd</strong>
//           </p>
//         </div>
//         <div className="rs-footer-social">
//           <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="facebook"><FaFacebookF /></a>
//           <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="twitter"><FaTwitter /></a>
//           <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="instagram"><FaInstagram /></a>
//           <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="linkedin"><FaLinkedin /></a>
//         </div>
//       </div>

//     </footer>
//   );
// };

// export default Footer;



import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import "./footer.css";
import img from './rootservicesQR.jpg';

const Footer = () => {
  const playStoreLink = "https://play.google.com/store/apps/details?id=com.rootservices.rootservices";

  return (
    <footer className="rs-footer">

      {/* Top Section */}
      <div className="rs-footer-top">

        {/* Quick Links */}
        <div className="rs-footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/servicehome">Services</Link></li>
            <li><Link to="/like">Liked</Link></li>
            <li><Link to="/profile">Profile</Link></li>
          </ul>
        </div>

        {/* Services */}
        <div className="rs-footer-col">
          <h4>Services</h4>
          <ul>
            <li><Link to="/specialoffer">Special Offers</Link></li>
          </ul>
        </div>

        {/* Play Store QR - Centered */}
        <div className="rs-footer-col playstore-col">
          <h4>Download App</h4>
          <div className="playstore-qr-center">
            <a href={playStoreLink} target="_blank" rel="noopener noreferrer">
              <img src={img} alt="Play Store QR" />
            </a>
            <a
              href={playStoreLink}
              target="_blank"
              rel="noopener noreferrer"
              className="download-btn"
            >
              Click here to download
            </a>
          </div>
        </div>

        {/* Location */}
        <div className="rs-footer-col rs-footer-location">
          <h4>Our Location</h4>
          <p>ROOT SERVICE</p>
          <p>SHOP.NO3, HK.HEIGHTS</p>
          <p>KALYANDURG, BYPASS, TOWARDS DMART, SERVICE RD</p>
          <p>RUDRAMPETA, ANANTAPUR, ANDHRAPRADESH</p>
          <p>PinCode: 515004, INDIA</p>
          <div className="rs-footer-map">
            <iframe
              title="Our Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18..."
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

      </div>

      {/* Bottom Section */}
      <div className="rs-footer-bottom">
        <div className="rs-footer-rights">
          <p>© {new Date().getFullYear()} Root Service. All rights reserved.</p>
          <p>
            Designed & Developed by <strong>Actrofite Infotech Pvt Ltd</strong>
          </p>
        </div>
        <div className="rs-footer-social">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="facebook"><FaFacebookF /></a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="twitter"><FaTwitter /></a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="instagram"><FaInstagram /></a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="linkedin"><FaLinkedin /></a>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
